import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SgTableWatermarkComponent } from './sg-table-watermark/sg-table-watermark.component';
import { SgExcelExportPluginDirective } from './excel-export';

@NgModule({
  imports: [CommonModule],
  declarations: [SgTableWatermarkComponent, SgExcelExportPluginDirective],
  exports: [SgTableWatermarkComponent, SgExcelExportPluginDirective],
})
export class SgTableExtensionModule {}
